import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import persistReducer from 'redux-persist/es/persistReducer';
import persistStore from 'redux-persist/es/persistStore';
import authSliceReducer from './slices/authSlice';
import staticSliceReducer from './slices/staticSlice';
import accountSliceReducer from './slices/accountSlice';
import reportSliceReducer from './slices/reportSlice';
import filterSliceReducer from './slices/filterSlice';
import productSlice from './slices/productSlice';
import breadcrumbSlice from './slices/breadcrumbSlice';
import userSliceReducer from './slices/userSlice';
import popupSlice from './slices/popupSlice';
import { authApi } from './api/authApi';
import { accountApi } from './api/accountApi';
import { staticApi } from './api/staticApi';
import { userApi } from './api/userApi';
import { productApi } from './api/productApi';
import { terminalApi } from './api/terminalApi';
import { reportApi } from './api/reportApi';
import { emailApi } from './api/emailApi';
import { breadcrumbApi } from './api/breadcrumbApi';
import loadingSlice from './slices/loadingSlice';
import { fileApi } from './api/fileApi';
import { externalApi } from './api/externalApi';
import externalSlice from './slices/externalSlice';
import configSlice from './slices/configSlice';

const authConfig = {
  key: 'auth',
  storage: storage,
  blacklist: ['password'],
};
const persistAccConfig = {
  key: 'account',
  storage: storage,
};
const persistProdConfig = {
  key: 'product',
  storage: storage,
};
const persistReportConfig = {
  key: 'report',
  storage: storage,
};
const persistBreadcrumbConfig = {
  key: 'breadcrumb',
  storage: storage,
};
const persistStaticData = {
  key: 'static',
  storage: storage,
};
const users = {
  key: 'user',
  storage: storage,
};
const persistFilterQuery = {
  key: 'filters',
  storage: storage,
};

const persistedAccountReducer = persistReducer(persistAccConfig, accountSliceReducer);
const persistedProductReducer = persistReducer(persistProdConfig, productSlice);
const persistedBreadcrumbReducer = persistReducer(persistBreadcrumbConfig, breadcrumbSlice);
const persistedReportReducer = persistReducer(persistReportConfig, reportSliceReducer);
const persistedStaticReducer = persistReducer(persistStaticData, staticSliceReducer);
const persistedUserReducer = persistReducer(users, userSliceReducer);
const authReducer = persistReducer(authConfig, authSliceReducer);
const filters = persistReducer(persistFilterQuery, filterSliceReducer);

export const store = configureStore({
  reducer: {
    authReducer,
    persistedUserReducer,
    persistedAccountReducer,
    persistedProductReducer,
    persistedReportReducer,
    persistedBreadcrumbReducer,
    persistedStaticReducer,
    loadingSlice,
    filters,
    configSlice,
    popupSlice,
    externalSlice,
    [authApi.reducerPath]: authApi.reducer,
    [accountApi.reducerPath]: accountApi.reducer,
    [staticApi.reducerPath]: staticApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [terminalApi.reducerPath]: terminalApi.reducer,
    [emailApi.reducerPath]: emailApi.reducer,
    [breadcrumbApi.reducerPath]: breadcrumbApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [externalApi.reducerPath]: externalApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(authApi.middleware)
      .concat(accountApi.middleware)
      .concat(staticApi.middleware)
      .concat(userApi.middleware)
      .concat(productApi.middleware)
      .concat(terminalApi.middleware)
      .concat(reportApi.middleware)
      .concat(emailApi.middleware)
      .concat(breadcrumbApi.middleware)
      .concat(fileApi.middleware)
      .concat(externalApi.middleware),
});

export const persistor = persistStore(store);
